import { Task } from 'src/app/model/sales/task.model';
import { Merchant } from './merchant.model';

export class UploadFile {
  email!: string;
  merchant!: Merchant;
  partnerId!: number;
  tasks!: Array<Task>;

  public load(data: any): this {
    Object.assign(this, data);

    if (data.merchant) {
      this.merchant = new Merchant().load(data.merchant);
    }

    return this;
  }
}
